import React from 'react';

const ProgressBar = ({ getProgressPercent }) => {
  return (
    <div className="input-progress-wrapper">
      <div className="progress-bar-container">
        <div
          className="progress-bar-fill"
          style={{ width: `${getProgressPercent()}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
